import { Dropdown, InputField, FormInput, Textareanot } from "../../components";
import Icons from "../../assets/icon";
import Functions from "./index.function";

const PersonalInformation = ({
  register,
  errors,
  setValue,
  control,
  select,
  setSelect,
  watch,
  trigger,
}) => {
  const { userData, userprofile, dropdowns, handleDropdwonSelect, isLoading } =
    Functions(setSelect, setValue, trigger);
  
  const genderValue = watch("gender");

  return (
    <div className={"flex flex-col xs:w-full sm:w-[90%] lg:w-[60%] mx-auto"}>
      {/* STAGE NAME - New field for talents */}
      <div className="relative w-full">
        <InputField
          control={control}
          label="Stage Name"
          type="text"
          name="stageName"
          maxLength={30}
          isMandatory={true}
          {...register("stageName", {
            required: "Stage Name is required",
            maxLength: {
              value: 30,
              message: "Stage Name cannot exceed 30 characters",
            },
            pattern: {
              value: /^[A-Za-z\s]+$/,
              message: "Stage Name can only contain letters",
            },
          })}
          onChange={(value) => setValue("stageName", value)}
          errors={errors}
        />
      </div>

      {/* REAL NAME - Prefilled from first_name + last_name */}
      <div className="relative w-full">
        <FormInput
          label={"Real Name"}
          control={control}
          userData={userprofile}
          name="full_name"
          type="text"
          maxLength={50}
          isMandatory={true}
          pattern={{
            value: /^[A-Za-z\s]+$/,
            message: "Real Name can only contain letters",
          }}
          errors={errors}
        />
      </div>

      {/* AGE - Calculated from date_of_birth or from profile */}
      <div className="relative w-full">
        <InputField
          control={control}
          label="Age"
          userData={userprofile}
          type="number"
          name="age"
          maxLength={2}
          isMandatory={true}
          iconStyle={"xs:w-5 xs:h-5 sm:w-5 sm:h-5 h-5 w-6 3xl:w-7 3xl:h-6"}
          {...register("age", {
            required: "Age is required",
            validate: (value) => {
              const numericAge = parseInt(value, 10);
              if (isNaN(numericAge)) return "Age must be a number";
              if (numericAge < 6) return "Age must be at least 6";
              if (numericAge > 90)
                return "Age must be less than or equal to 90";
              return true;
            },
            maxLength: {
              value: 2,
              message: "Age cannot exceed 2 digits",
            },
          })}
          onChange={(value) => setValue("age", value)}
          errors={errors}
        />
      </div>

      {/* AGENT CODE - Optional field */}
      <div className="relative w-full">
        <InputField
          control={control}
          label="Agent Code"
          type="text"
          name="agent_code"
          iconStyle={"xs:w-5 xs:h-5 sm:w-5 sm:h-5 h-5 w-6 3xl:w-7 3xl:h-6"}
          maxLength={30}
          onChange={(value) => setValue("agent_code", value)}
        />
      </div>

      {/* GENDER & ETHNICITY - Side by side */}
      <div className="flex items-center sm:gap-x-6 xs:flex-col">
        {/* GENDER - Dropdown already has Controller inside, no need to wrap again */}
        <div className="relative xs:w-full sm:w-1/2 lg:w-1/2">
          <Dropdown
            control={control}
            rightIcon={Icons.arrowIcon}
            label="Gender"
            options={dropdowns?.gender || []}
            name="gender"
            handleSelect={(value) => {
              console.log("🎯 Gender selected:", value);
              setValue("gender", value, { shouldValidate: true });
              setSelect((prev) => ({ ...prev, gender: value }));
            }}
            valueoption="gender_id"
            valueName="gender"
            isMandatory={true}
            errors={errors}
            isLoading={isLoading}
          />
        </div>

        {/* ETHNICITY - New talent-specific field */}
        <div className="relative xs:w-full sm:w-1/2 lg:w-1/2">
          <Dropdown
            control={control}
            rightIcon={Icons.arrowIcon}
            label={"Ethnicity"}
            options={dropdowns?.ethnicity}
            name={"ethnicity"}
            handleSelect={(value) => handleDropdwonSelect("ethnicity", value)}
            valueName="name"
            valueoption="ethnicity_id"
            isMandatory={true}
            errors={errors}
            isLoading={isLoading}
          />
        </div>
      </div>

      {/* ABOUT ME - Text area for bio */}
      <div className="w-full lg:pt-5">
        <Textareanot
          lable={"About Me"}
          name={"about_me"}
          setValue={setValue}
          isMandatory={false}
        />
      </div>
    </div>
  );
};

export default PersonalInformation;